<tt-page>
    <tt-card class="col-xs-12 col-md-6 sp-0">
        <tt-button-goto [ttText]="'travelwagesets_new'" (ttClick)="goToFunc('travelwageset')" ttIcon="fa fa-solid fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListTravelWageSets"></tt-list>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-5">
        <tt-button class="col-xs-12 sp-0" tt-text="travelwagesets_new" tt-click="vm.goToFunc('travelwageset')" tt-text-align="left" tt-icon="fa fa-solid fa-plus" tt-icon-pull-right="true"></tt-button>
    </tt-card>
    <tt-list class="col-xs-12 col-md-4 sp-5" list-items="vm.model.itemsListTravelWageSets" badge="" ltype="" design-var="s12t0"></tt-list>
</tt-page>-->
